import { faqItems } from '@/mocks/faq';

/**
 * The subset of the shared FAQ that is shown on the Get EA page.
 *
 * Both the visible accordion (MiniFaq) and the page's FAQPage structured data
 * read from this single array, so the JSON-LD can never drift away from what a
 * visitor actually sees on the page — the same pattern used on How It Works.
 */
const GET_EA_FAQ_IDS = ['free', 'broker', 'balance', 'strategy'];

export interface GetEaFaqItem {
  id: string;
  question: string;
  answer: string;
}

export const GET_EA_FAQ: GetEaFaqItem[] = faqItems.filter((item) => GET_EA_FAQ_IDS.includes(item.id));